export default function() {
    buildNav('.nav--primary .nav__item--parent')
    buildNav('.nav--top .nav__item--parent')
    $('.the-navs .nav__item--parent').on({
        click: function(event){
            const menuId = $(this).attr('data-id');
            if($('.subnav-parent-id-'+menuId).hasClass("subnav__item--active")){
                $('.subnav-parent-id-'+menuId).removeClass("subnav__item--active");
            } else {
                $(".subnav__item--active").removeClass("subnav__item--active");
                $('.subnav-parent-id-'+menuId).addClass("subnav__item--active");
            }
            event.preventDefault();
        }
        // mouseenter: function () {
        //     const menuId = $(this).attr('data-id');
        //     //console.log(menuId);
        //     //$(".subnav__item--active").removeClass("subnav__item--active");
        //     $('.subnav-parent-id-'+menuId).addClass("subnav__item--active");
        // },
        // mouseleave: function (e) {
        //     console.log(e.relatedTarget);
        //     if($(e.relatedTarget).parents(".banner__subnav-wrap").length){
        //         console.log('on subnav');
        //     } else {
        //         $(".subnav__item--active").removeClass("subnav__item--active");
        //     }
        // }
    });
    $(document).on("click",(event) => {
        if ($(event.target).parents(".banner__subnav-wrap").length > 0 || $(event.target).hasClass("nav__link--parent")) {
            event.stopPropagation();
        } else {
            $(".subnav__item--active").removeClass("subnav__item--active");
        }
    });
}
const buildNav = function(selector){
    // transpose subnavs
    $(selector).each(function(){
        //console.log($(this).find('.nav__children').clone())
        const childList = $(this).find('.nav__children');
        const copy = childList.clone();
        const title = $(this).find(".nav__link--parent").text()
        const html = $('<div class="subnav__item subnav-parent-id-'+copy.attr('data-parent-id')+'"><div class="subnav__inner"><div class="subnav__title">'+title+'</div><div class="subnav__menu"></div></div></div>');

        childList.remove();
        copy.appendTo(html.find(".subnav__menu"));
        html.appendTo(".banner__subnav");
    });
}